import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Head } from '@/components/ui/Typography/Heading/Head';
const bgColors = {
    gradientDarkGreen: 'bg-gradient-to-r from-gradient-dark-green-from to-gradient-dark-green-to',
    gradientLiteBlue: 'bg-gradient-to-r from-gradient-lite-blue-from to-gradient-lite-blue-to',
    gray: 'bg-blue-gray-100',
    none: '',
    primary: 'bg-navy-100',
};
const fixTextPositions = {
    center: 'text-center',
    left: 'text-left',
};
export const BandHead = (props) => {
    const { bgColor = 'primary', children, className = '', fixTextPosition, tagName = 'div', textClassName = '', } = props;
    const Tag = tagName;
    return (_jsx(Tag, Object.assign({ className: clsx('p-20', bgColors[bgColor], fixTextPosition
            ? fixTextPositions[fixTextPosition]
            : 'text-left lg:text-center', className) }, { children: _jsx(Head, Object.assign({ className: textClassName, color: 'white', size: 'sm', tagName: 'div' }, { children: children })) })));
};
export const bandHeadBgColor = bgColors;
